/**
 * L2-P3: moved to @miq/utils (core-utils/not-null.ts). This shim keeps the old
 * import path working; new code should import from '@miq/utils'.
 */
export { isNotNull, isNull } from '@miq/utils';
